<template>
  <div id="app" v-cloak>
  
	<router-view ></router-view>   
	
	<div id="top">
		
		<div>{{title}}
		<a href="https://beian.miit.gov.cn/">{{title1}}</a>
		</div>
		<div>{{sitename}}</div>
	</div>
	
	<div class="fankui" @click="open()">
		<svg t="1623567026856" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2669" width="28" height="28"><path d="M810.1 484.9c-15.9 0-28.9 12.9-28.9 28.9v301.5c0 74.3-60.5 134.8-134.8 134.8H216.8C142.4 950 82 889.6 82 815.2V385.6c0-74.3 60.5-134.8 134.8-134.8h290.7c15.9 0 28.9-12.9 28.9-28.9S523.5 193 507.5 193H216.8c-106.2 0-192.6 86.4-192.6 192.6v429.6c0 106.2 86.4 192.6 192.6 192.6h429.6c106.2 0 192.6-86.4 192.6-192.6V513.8c-0.1-16-13-28.9-28.9-28.9z" fill="#ffffff" p-id="2670"></path><path d="M533.5 335.1c-9.7 9.7-27.6 33.6-70.5 128.1-11.9 26.3-22.8 51.5-29.8 68-3.8 9.1-7 16.5-9.1 21.7-5 11.9-8 19.1-3.4 30.2 6.1 14.7 22.9 21.7 37.6 15.7 0.5-0.2 47.7-19.6 97.9-42.4 94.6-42.9 118.4-60.8 128.1-70.5l195.2-195.2-150.8-150.8-195.2 195.2z m110 110.1c-12.4 12.4-73.9 42.7-141.7 72.5 29.8-67.8 60.1-129.2 72.5-141.7l154.4-154.4 69.2 69.2-154.4 154.4zM971.7 47.8c-41.6-41.6-109.3-41.6-150.9 0l-49.9 50 150.9 150.9 50-49.9c41.5-41.7 41.5-109.4-0.1-151z m-40.9 110l-9.1 9.1-69.2-69.2 9.1-9.1c19.1-19.1 50.1-19.1 69.2 0s19.1 50.2 0 69.2z" fill="#ffffff" p-id="2671"></path></svg>
		<span>反馈</span>
	</div>
	<div class="open"  v-if="types==1" @click="close()"></div>
	<div class="form1" v-if="types==1">
		<div class="form-div">
			<div class="title">我要反馈</div>
			<el-form ref="form" :model="form" label-width="80px">
			  <el-form-item label="联系方式">
			    <el-input v-model="form.phone"></el-input>
			  </el-form-item>
			  <el-form-item label="反馈内容">
			    <el-input type="textarea" v-model="form.body"></el-input>
			  </el-form-item>
			  <div style="height: 10px;"></div>
			  <el-form-item>
			    <el-button type="primary" @click="onSubmit">提交</el-button>
			    <el-button @click="close()">取消</el-button>
			  </el-form-item>
			</el-form>
			
			
		</div>
	</div>
	
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Login from './components/login/login.vue'

export default {
	name: 'app',
	 metaInfo() {
	      return {
			title : this.metaData['title'], 
			meta: this.metaData['meta'],
			
			
	      }
	
	    },
	data() {
		return {
			type : 0,
			title :'数独交流社区',
			sitename : 'Copyright © www.dujiaoyu.net, All Rights Reserved.',
			title1 : '',
			types  : 0,
			form: {
			    phone: '',
			    body: ''
			},
			 metaData: [
				
			]
		
		}
	},
	
	created(){
		let that = this;
		that.$http('get','/api/v1/config?name=title') .then(function (res) {
			that.title = res.data;
		});	
		that.$http('get','/api/v1/config?name=title1') .then(function (res) {
			that.title1 = res.data;
		});	
		that.$http('get','/api/v1/config?name=sitename') .then(function (res) {
			that.sitename = res.data;
		});
		that.$http('get','/api/v1/seo') .then(function (res) {
			that.metaData= res.data;
		
		});
		console.log(localStorage.token);return;
		if(localStorage.token && that.$route.path=='/'){
			that.$router.push('/index');	 
		}
	
 },
 methods:{
	onSubmit() {
		let that = this;
		that.$http('post','/api/v1/feedback',{'form':that.form}) .then(function (res) {
			if(res.code==200){
				 that.$message({
				          message: res.msg,
				          type: 'success'
				        });
				that.types = 0;	
				that.form  = []
			}else{
				that.$message.error(res.msg);
			}
			
		});	
		
		console.log(that.form);
	},
	open(){
		this.types = 1;
	},
	close(){
		this.types  = 0;
	}
 },
  components: {
   Login
  }
}
</script>
<style lang="less">
#app {
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  // min-width:71.5rem;
}
#top {
	margin-top: 20px;
	width: 100%;
	color: #CCCCCC;
	text-align: center;
	height: 50px;
	div {
		color: #CCCCCC;
		font-size: 12px;
		height: 20px;
	}
}
a {
	text-decoration: none;
		color: #999999;
}
.fankui {
	position: fixed;
	bottom: 1.875rem;
	right: 1.25rem;
	padding-left: 24px;
	padding-right: 24px;
	padding-bottom: 6px;
	padding-top: 6px;
	border-radius: 38px;
	background-color:#3d5cffbd ;
	z-index: 99;
	span {
		top: -6px;
		position: relative;
		font-size: 18px;
		padding-left: 2px;
		color: #ffffff;
	}
	
}
.form1 {
	width: 100%;
	position: fixed;
	// height: 100%;
	z-index: 998;
	top: 0;
	.form-div {
		z-index: 999;
		border-radius: 30px;
		background-color: #ffffff;
		width: 350px;
		height: 250px;
		margin: auto;
		margin-top: 200px;
		padding-left:30px;
		padding-right: 30px;
		padding-top: 30px;
		padding-bottom: 30px;
		.title {
			text-align: center;
			padding-bottom: 10px;
			font-size: 18px;
			border-bottom: 1px solid #93898929;
		}
		.el-form {
			margin-top: 20px;
		}
	}
}
.open {
	background-color: #3333332e;
	z-index: 998;
	width: 100%;
	position: fixed;
	height: 100%;
	top: 0;
}

[v-cloak]{
   display: none !important;
}
</style>
